import React from 'react';
const PrivacyPolicy = () => {
  return (
    <main
      className="main-content"
      style={{
        maxWidth: '498px',
        margin: '0 auto',
        paddingTop: '80px',
        paddingBottom: '1rem',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        boxSizing: 'border-box',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem', textAlign: 'center' }}>
        Politique de Confidentialité
      </h1>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '1rem',
          fontSize: '0.85rem',
          lineHeight: '1.35',
        }}
      >
        <section>
          <h2 style={{ fontSize: '1rem', marginBottom: '0.2rem' }}>Responsable de traitement</h2>
          <p style={{ margin: 0 }}>
            L'association <strong>Les Z'Ineuvitables</strong> (Neuville-en-Ferrain) traite vos données conformément au RGPD pour la gestion des réservations, de la billetterie et la mesure d'audience.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: '1rem', marginBottom: '0.2rem' }}>Données & Durées</h2>
          <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
            <li>
              <strong>Réservations / Contact :</strong> nom, e-mail, téléphone (exécution de service, conservé 1 an).
            </li>
            <li>
              <strong>Cookies Analytics :</strong> mesure d'audience Google Analytics soumise à votre consentement (conservés 13 mois max).
            </li>
          </ul>
        </section>

        <section>
          <h2 style={{ fontSize: '1rem', marginBottom: '0.2rem' }}>Utilisation & Transferts</h2>
          <p style={{ margin: '0 0 0.3rem 0' }}>
            Vos données servent exclusivement à la gestion de vos billets et aux réponses à vos demandes. Aucune donnée n'est revendue à des tiers.
          </p>
          <p style={{ margin: 0 }}>
            Les outils d'analyse (Google Analytics) encadrent les transferts hors UE via les clauses contractuelles types.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: '1rem', marginBottom: '0.2rem' }}>Vos droits & Contact</h2>
          <p style={{ margin: '0 0 0.3rem 0' }}>
            Accès, rectification, suppression ou réclamation auprès de la CNIL (cnil.fr).
          </p>
          <p style={{ margin: 0 }}>
            Contact : <a href="mailto:contact@zineuvitables.org">contact@zineuvitables.org</a>
          </p>
        </section>
      </div>
    </main>
  );
};

export default PrivacyPolicy;